export default "__VITE_ASSET__3808086b__"